import { render, staticRenderFns } from "./keWenLangDu.vue?vue&type=template&id=fe8836a8&scoped=true&"
import script from "./keWenLangDu.vue?vue&type=script&lang=js&"
export * from "./keWenLangDu.vue?vue&type=script&lang=js&"
import style0 from "./keWenLangDu.vue?vue&type=style&index=0&id=fe8836a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe8836a8",
  null
  
)

export default component.exports